/**
 * 通用加载占位组件。
 *
 * 居中显示进度环与提示文案，用于列表/详情加载态。
 *
 * @module components/common/Loading
 */
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

/** Loading 组件属性。 */
interface LoadingProps {
  /** 提示文案。 */
  message?: string;
  /** 是否占满父容器高度（默认 true）。 */
  fullHeight?: boolean;
}

/**
 * 加载占位组件。
 *
 * @param props 组件属性。
 * @returns 加载占位元素。
 */
export default function Loading({
  message = '加载中...',
  fullHeight = true,
}: LoadingProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: fullHeight ? 10 : 2,
      }}
    >
      <CircularProgress size={32} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}
